export const OPERATIONS_BASE_ROUTE = '/operations'
export const DPR_ROUTE = `${OPERATIONS_BASE_ROUTE}/daily-position-reports`
export const DPR_ROUTE_SEGMENT = 'daily-position-reports'
export const COASTAL_POSITION_REPORT_ROUTE = `${OPERATIONS_BASE_ROUTE}/coastal-position-report`
